import axios from "axios";

interface ErrorResponse {
  message?: string;
  errors?: Record<string, string[]>;
}

export const getAuthorizationErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  if (!axios.isAxiosError<ErrorResponse>(error)) {
    return error instanceof Error ? error.message : fallback;
  }

  const validationMessage = error.response?.data?.errors
    ? Object.values(error.response.data.errors).flat()[0]
    : undefined;

  return error.response?.data?.message ?? validationMessage ?? fallback;
};
